import React from 'react'
import agent from '../agent'
import TransactionList from './widgets/TransactionList';
import Loading from './widgets/Loading'
import { connect } from 'react-redux'
import {
    ACCOUNT_RAW_PAGE_LOADED,
    ACCOUNT_RAW_PAGE_UNLOADED,
    ACCOUNT_WALLET_EXPORT
} from '../constants/actionTypes'

const mapStateToProps = state => ({
    ...state.account,
    currentUser: state.common.currentUser,
    csvData: state.account.csvData
});

const mapDispatchToProps = dispatch => ({
    onLoad: payload =>
        dispatch({ type: ACCOUNT_RAW_PAGE_LOADED, payload }),
    onUnload: () =>
        dispatch({ type: ACCOUNT_RAW_PAGE_UNLOADED }),
    onExportWallet: (payload) => {
        dispatch({ type: ACCOUNT_WALLET_EXPORT, payload })
    }
});


class AccountDetail extends React.Component {
    constructor() {
        super()
        this.state = {
            resetSyncTimeButtonText: 'Reset Sync Time',
        }
        this.exportWallet = (externalAddress) => ev => {
            ev.preventDefault()
            this.props.onExportWallet(agent.Accounts.exportWallet(externalAddress))
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.csvData) {
            var data = new Blob([nextProps.csvData], { type: 'text/csv' });
            var csvURL = window.URL.createObjectURL(data);
            var tempLink = document.createElement('a');
            tempLink.href = csvURL;
            tempLink.setAttribute('download', `${new Date()}_tasks.csv`);
            tempLink.click();
        }
    }

    componentWillMount() {
        this.props.onLoad(
            agent.Accounts.getWallet(this.props.match.params.address)
        );
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        if (!this.props.account) {
            return (
                <Loading />
            )
        }
        const transactions = this.props.account.transactions ? this.props.account.transactions.transactions : []

        return (
            <div className="pane">
                <h1>Wallet Detail</h1>
                <div className="infoGroup">
                    <div className="infoPair">
                        <label>Address:</label> <span>{this.props.account.publickey}</span>
                    </div>
                    <div className="infoPair">
                        <label>Symbol:</label> <span>{this.props.account.symbol}</span>
                    </div>
                    <div className="infoPair">
                        <label>Amount:</label> <span>{this.props.account.amount}</span>
                    </div>
                </div>
                <TransactionList transactions={transactions} loading={this.props.loading} />
                <div className="infoGroup">
                    <div className="infoAction">
                        <button className="buttonAction" onClick={this.exportWallet(this.props.account.publickey)}>Export Wallet</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountDetail);



// WEBPACK FOOTER //
// ./src/components/AccountRawDetail.js